import { useState } from 'react';
import { useCancelableEffect } from 'packages/smart-home-support/hooks';
import { MaybeUser } from 'packages/smart-home-support/pages/auth/models';
import { Device as APIDevice } from 'packages/smart-home-support/api/models';
import { deviceTypes } from './data';
import { Devices } from './models';

const makeDeviceLabel = (baseName: string, number: number) => `${baseName} ${number}`;

const getDeviceLabel = (device: APIDevice, devices: Array<APIDevice>) => {
  const ofType = devices.filter(({ type }) => type === device.type).sort((a, b) => a.created - b.created);
  const number = ofType.findIndex(({ id }) => device.id === id) + 1;
  return makeDeviceLabel(deviceTypes[device.type].label, number);
};

export const useDevices = (user: MaybeUser): [typeof devices, typeof setDevices] => {
  const [devices, setDevices] = useState<Devices>();

  useCancelableEffect(() => {
    if (user && user.home.devices) {
      setDevices(
        user.home.devices.map((device) => ({
          ...device,
          label: getDeviceLabel(device, user.home.devices!),
        }))
      );
    }
  }, [user]);

  return [devices, setDevices];
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/hooks.ts